export function animateScrollToY (top, duration) {
  const start = window.scrollY
  const distance = top - start
  if (distance === 0 || duration <= 0) {
    window.scrollTo(0, top)
    return
  }

  const startTime = performance.now()
  const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t)

  const step = (now) => {
    const progress = Math.min((now - startTime) / duration, 1)
    window.scrollTo(0, start + distance * easeInOutQuad(progress))
    if (progress < 1) window.requestAnimationFrame(step)
  }

  window.requestAnimationFrame(step)
}
